import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import useCookieConsent from 'utils/cookieConsent';
import { Routes } from 'utils/routes';

export default function CookieConsent() {
    const [cookieConsent, setCookieConsent] = useCookieConsent();
    const [display, setDisplay] = useState(false);

    const isServer = typeof window === 'undefined';

    useEffect(() => {
        if (isServer) return;
        if (cookieConsent !== null) return setDisplay(false);
        const show = async () => {
            await new Promise((res) => setTimeout(res, 500));
            setDisplay(true);
        };
        show();
    }, [cookieConsent, isServer]);

    const acceptCookie = () => {
        setCookieConsent(true);
        setDisplay(false);
    };

    const rejectCookie = () => {
        setCookieConsent(false);
        setDisplay(false);
    };

    return (
        <div style={{
            transform: display ? 'none' : 'translateY(500px)',
            transition: 'transform 0.5s',
            position: 'fixed',
            bottom: 0,
            right: 20,
            background: '#000',
            color: 'white',
            padding: '10px',
            maxWidth: '400px',
            boxSizing: 'border-box',
            textAlign: 'left',
            boxShadow: '0 0 2px rgb(0 0 0 / 20%), 0 -2px 4px rgb(0 0 0 / 20%)',
            zIndex: 2000,
        }}>
            <strong>Vi minimerer dit digitale fodspor</strong>
            <p>
                Vi bruger kun én cookie på penly.dk. Den fortæller os, om det er dit
                første besøg på sitet. Vi følger dig <strong>ikke</strong> rundt på nettet, og
                vi sender <strong>ikke</strong> dine data videre til andre. <Link href={ Routes.Cookies }>Læs mere</Link>
            </p>
            <button style={{ marginRight: '10px' }} onClick={ acceptCookie }>Acceptér</button>
            <button onClick={ rejectCookie }>Afvis</button>
        </div>
    );
};
